import * as React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import { ResponsiveTable } from '../../components/Layout';
import { useGetProblemsQuery } from '../../graphql/queries/getProblems.generated';
import { Routes } from '@/utils/routes';
import { Link } from 'react-router-dom';

type ProblemsProps = {
  uuid: string | null;
};

export const ProblemsTab = function ProblemsTab({ uuid }: ProblemsProps) {
  if (uuid == null) {
    return <span>No id for user</span>;
  }

  const { data, loading } = useGetProblemsQuery({
    variables: {
      uuid: uuid,
    },
  });

  const problems = data?.getProblems || [];

  return (
    <div>
      <h4>Problems</h4>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <ResponsiveTable>
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Creation Timestamp</th>
              <th>Store</th>
              <th>Event Data</th>
            </tr>
          </thead>
          <tbody>
            {problems.map((p) => {
              return (
                <tr key={p.id}>
                  <td>{p.event_name}</td>
                  <td>{p.creation_timestamp}</td>
                  <td>
                    {p.store_text_id != null ? (
                      <Link to={Routes.pickpackStores(p.store_text_id)}>
                        {p.store_name}
                      </Link>
                    ) : (
                      'undefined'
                    )}
                  </td>
                  <td>{p.event_data}</td>
                </tr>
              );
            })}
          </tbody>
        </ResponsiveTable>
      )}
    </div>
  );
};
